module.exports = __webpack_public_path__ + "static/media/bg-flora-desk.e11e50a8.svg";